import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import { Typography, Grid } from '@material-ui/core';
import CustomTable from 'components/CustomTable';
import { UPDATE_SITE_INFO_INSIDE_VALIDITY } from 'store/key';
import { getSystemMessage } from 'store/system/systemMessageReducer';
import { declareInvAutoFilledRoles, checkTableColumnCompleted } from 'utility/formValidate';
import { declareInvKey } from 'constants/globalEnum';

const useStyles = makeStyles((theme) => ({
    item: {
        paddingBottom: theme.spacing(1),
    },
}));

export default function DeclarationAndEndorsementFormLayout(props) {
    const classes = useStyles();
    const {
        siteInfoId,
        formId,
        disableOnPermission,
        dispatch,
        siteInfoInsideValid,
        declareInvColumns,
        declareInvRows,
        coiInvolved,
        handleEditClick,
        disableOldDataDelete,
        applicationCreateDtm,
        mapShowRow,
    } = props;

    /** check declaration's table rows of auto-filled for completeness when click "Save" button start */
    const [declareInvValid, setDeclareInvValid] = useState(true);
    useEffect(() => {
        // check row that has the smallest id no.
        const noPIs = declareInvRows?.filter((entry) => entry.role !== 'Principal Investigator');
        const sortedDeclareInv =
            declareInvRows?.filter((entry) => entry.role === 'Principal Investigator')?.sort((a, b) => a?.id - b?.id) ||
            [];
        const tempDeclareInvRows = sortedDeclareInv?.concat(noPIs);
        const valid = checkTableColumnCompleted(tempDeclareInvRows ?? []);
        setDeclareInvValid(valid);
        // eslint-disable-next-line
    }, [declareInvRows]);

    useEffect(() => {
        dispatch({
            type: UPDATE_SITE_INFO_INSIDE_VALIDITY,
            payload: {
                applicationFormId: formId,
                siteInfoId: siteInfoId,
                formKey: 'declareInvValid',
                isValid: declareInvValid,
            },
        });
        // eslint-disable-next-line
    }, [declareInvValid]);
    /** check declaration's table rows of auto-filled for completeness when click "Save" button end */

    /** if coiInvolved=false and row existInDB, hide coi's row */
    const mapCurrentRows = (rows) => {
        let newRows = [];
        if (!coiInvolved) {
            rows.forEach((row) => {
                if (row.role !== declareInvAutoFilledRoles[1]) {
                    newRows.push(row);
                }
            });
        } else {
            newRows = mapShowRow?.(rows, declareInvKey) ?? rows;
        }
        return newRows;
    };
    const newRows = mapCurrentRows?.(declareInvRows) ?? [];

    return (
        <Grid container className={classes.item}>
            <Grid container>
                {siteInfoInsideValid?.declareInvValid === false && (
                    <Grid container>
                        <Typography color="error">
                            {getSystemMessage('checkCompleteness', [
                                '"table column: Position, Responsibility for Clinical oversight"',
                            ])}
                        </Typography>
                    </Grid>
                )}
                <CustomTable
                    disableOnPermission={disableOnPermission}
                    isEditAllow={true}
                    onEdit={(row) => handleEditClick(row, declareInvKey)}
                    columns={declareInvColumns}
                    rows={newRows}
                    allowResize
                    defaultSortKey={'role'}
                    defaultSortOnFrontend
                    fullWidthTable={false}
                    disableOldDataDelete={disableOldDataDelete}
                    applicationCreateDtm={applicationCreateDtm}
                />
            </Grid>
        </Grid>
    );
}
